import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import Util from "@/util";

export const router = createRouter({
    history: createWebHistory(),
    routes
})

// 路由守卫
router.beforeEach((to, _from, next) => {
    // 检查是否需要登录验证
    if (to.meta.requiresAuth) {
        // 检查是否已登录
        if (!Util.isLoggedIn()) {
            // 未登录，跳转到登录页
            next('/admin/login')
            return
        }
    }
    
    // 如果已登录且访问登录页，跳转到仪表板
    if (to.path === '/admin/login' && Util.isLoggedIn()) {
        next('/admin/dashboard')
        return
    }
    
    next()
})